var map = {
	"./404.png": "3dfc",
	"./cas.png": "d2cd",
	"./ding_talk.png": "79c7",
	"./dingtalkicon.png": "3d4c",
	"./idsLogin/bg.png": "c474",
	"./idsLogin/codeicon.png": "3285",
	"./idsLogin/founder.png": "871e",
	"./idsLogin/noseeicon.png": "4c71",
	"./idsLogin/password.png": "815d",
	"./idsLogin/phone.png": "2343",
	"./idsLogin/reset.png": "2d6d",
	"./idsLogin/seeicon.png": "27e0",
	"./idsLogin/user.png": "022a",
	"./login_bg.png": "963d",
	"./login_form_bg.png": "a9df",
	"./logo.png": "9d64",
	"./logo_h.png": "3b73",
	"./orcid.png": "c88b",
	"./orcidicon.png": "e60b",
	"./sprite.png": "9832",
	"./wechat-work.png": "6221",
	"./wechat_mp.png": "09e6",
	"./wechat_open.png": "8544",
	"./wechaticon.png": "e4da",
	"./weibo.png": "2d18",
	"./weiboicon.png": "f030"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e078";